// MentorInfo.jsx
import React, { useState, useEffect } from "react";
import { FaSchool } from "react-icons/fa";
import Card from "components/card";
import { getUserProfile } from "api";

const MentorInfo = () => {
  const [school, setSchool] = useState("");

  useEffect(() => {
    const fetchMentorData = async () => {
      try {
        // Fetch user profile to get the school
        const userProfile = await getUserProfile();
        const userSchool = userProfile?.user?.school || "No school found";
        setSchool(userSchool);
      } catch (error) {
        console.error("Error fetching mentor data", error);
      }
    };

    fetchMentorData();
  }, []);

  return (
    <Card extra="w-full h-full p-6">
      <div className="flex flex-col items-center justify-center w-full h-full rounded-xl border-[2px] border-dashed border-gray-200 dark:border-navy-700 p-6">
        <FaSchool className="text-6xl text-brand-500 dark:text-white mb-4" />
        <h4 className="text-2xl font-bold text-navy-700 dark:text-white mb-4">
          {school}
        </h4>
      </div>
    </Card>
  );
};

export default MentorInfo;
